import { render, staticRenderFns } from "./GuideTabs.vue?vue&type=template&id=6f36efde&scoped=true&"
import script from "./GuideTabs.vue?vue&type=script&lang=js&"
export * from "./GuideTabs.vue?vue&type=script&lang=js&"
import style0 from "./GuideTabs.vue?vue&type=style&index=0&id=6f36efde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36efde",
  null
  
)

export default component.exports